import OrganizationCategory from './OrganizationCategory';

export default OrganizationCategory;
